import axios from 'axios';
import { computed, reactive, toRefs } from 'vue';

const state = reactive({
  user: {},
});
const isDigipenEmail = computed(() => state.user?.email?.toLowerCase().endsWith('@digipen.edu') ?? false);
export default function useAuth() {
  const getUser = async () => {
    try {
      if (!state.user.userId) {
        const response = await axios.get(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/auth/getUser`);
        state.user = response.data;
      }

      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  const login = () => {
    window.location.href = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/auth/login`;
  };

  const logout = () => {
    // state.user = {};
    window.location.href = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/auth/logout`;
  };

  const hasRoles = (...args) => {
    if (state.user.roles === undefined) {
      return false;
    }
    if (state.user.roles.includes('R&D')) {
      return true;
    }
    for (let i = 0; i < args.length; i += 1) {
      if (state.user.roles.includes(args[i])) {
        return true;
      }
    }
    return false;
  };

  const impersonate = async (username) => {
    try {
      await axios.post(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/auth/impersonate`, null, {
        params: { username },
      });
      window.location.reload();
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  const stopImpersonating = async () => {
    try {
      await axios.post(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/auth/stopImpersonating`);
      window.location.reload();
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  return {
    ...toRefs(state),
    login,
    logout,
    getUser,
    hasRoles,
    isDigipenEmail,
    impersonate,
    stopImpersonating,
  };
}
